import { Injectable } from '@angular/core';
import { DynamicConfig } from '@statsig/js-client';
import { StatsigService } from '@services/statsig.service';

export enum VEHICLE_PROFILE_V2_CONFIG_FEATURE_FLAGS {
  VEHICLE_PROFILE_V2_CONFIG = 'vehicle-profile-v2-config',
}

@Injectable({ providedIn: 'root' })
export class VehicleProfileV2DynamicConfigService {
  private config: DynamicConfig;

  constructor(private statsigService: StatsigService) {
    this.config = this.statsigService.evaluateDynamicConfig(
      VEHICLE_PROFILE_V2_CONFIG_FEATURE_FLAGS.VEHICLE_PROFILE_V2_CONFIG);
  }

  public vehicleProfileV2DynamicConfig(): DynamicConfig {
    return this.config as DynamicConfig;
  }

  public get vehicleProfileV2Enable(): boolean {
    return this.config.get('enable', false);
  }

  public get vehicleProfileV2Iteration(): number {
    return this.config.get('iteration', 0);
  }

  public get isVehicleProfileV2Phase2Enabled(): boolean {
    return this.vehicleProfileV2Iteration === 2 || this.vehicleProfileV2Enable;
  }

  public get isVehicleProfileV2Phase1Enabled(): boolean {
    return this.vehicleProfileV2Iteration === 1 || this.isVehicleProfileV2Phase2Enabled;
  }
}
